import { render, staticRenderFns } from "./PortalAccounts.vue?vue&type=template&id=81f86676&"
import script from "./PortalAccounts.ts?vue&type=script&lang=ts&"
export * from "./PortalAccounts.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports